<template>
  <div v-if="loading" class="col-md-12 text-center">
    <span style="font-size: 24px">
      <i :class="'fas ' + icone"></i>
    </span>

    <p>{{ mensagem }}</p>
  </div>
</template>

<script>
export default {
  props: ["loading", "mensagem", "icone"],
};
</script>

<style>
</style>
